import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PropTypes from "prop-types";
import { isEnabledDiscoCompany } from "../../utils/adminCompany";
import "./DashboardCompanyToolbar.scss";

export const DISCO_COMPANY_OPTIONS = [
  { code: "11", label: "LESCO" },
  { code: "12", label: "GEPCO" },
  { code: "13", label: "FESCO" },
  { code: "14", label: "IESCO" },
  { code: "15", label: "MEPCO" },
  { code: "26", label: "PESCO" },
  { code: "27", label: "HAZECO" },
  { code: "37", label: "HESCO" },
  { code: "38", label: "SEPCO" },
  { code: "48", label: "QESCO" },
  { code: "59", label: "TESCO" },
];

const getCompanyLabel = (code) =>
  DISCO_COMPANY_OPTIONS.find((item) => item.code === String(code))?.label || "";

export default function DashboardCompanyToolbar({
  selectedCompanyCode,
  onCompanyChange,
  onShow,
  loading,
  showDisabled,
  activeCompanyLabel,
  activeCompanyCode,
}) {
  const isShowReady = Boolean(selectedCompanyCode) && !showDisabled && !loading;
  const activeShortName = getCompanyLabel(activeCompanyCode);

  return (
    <Box className="dashboard-company-toolbar" component="section" aria-label="Distribution filter">
      <div className="dashboard-company-toolbar__accent" aria-hidden />

      <div className="dashboard-company-toolbar__brand">
        <div className="dashboard-company-toolbar__icon-wrap">
          <BusinessRoundedIcon className="dashboard-company-toolbar__icon" aria-hidden />
        </div>

        <div className="dashboard-company-toolbar__info">
          <div className="dashboard-company-toolbar__meta">
            <span className="dashboard-company-toolbar__badge">Distribution</span>
            {activeShortName ? (
              <span className="dashboard-company-toolbar__disco-chip">{activeShortName}</span>
            ) : null}
          </div>

          {activeCompanyLabel ? (
            <div className="dashboard-company-toolbar__headline">
              <span className="dashboard-company-toolbar__hint">Showing data for</span>
              <h2 className="dashboard-company-toolbar__company-name">{activeCompanyLabel}</h2>
            </div>
          ) : (
            <p className="dashboard-company-toolbar__placeholder">
              Select a distribution company to view dashboard data
            </p>
          )}
        </div>
      </div>

      <div className="dashboard-company-toolbar__actions">
        <span className="dashboard-company-toolbar__actions-label">Switch DISCO</span>
        <div
          className={`dashboard-company-toolbar__combo${
            isShowReady ? " dashboard-company-toolbar__combo--ready" : ""
          }`}
        >
          <FormControl size="small" className="dashboard-company-toolbar__select-wrap">
            <Select
              value={selectedCompanyCode || ""}
              onChange={(e) => onCompanyChange(e.target.value)}
              displayEmpty
              className="dashboard-company-toolbar__select"
              disabled={loading}
              renderValue={(value) => getCompanyLabel(value) || "Select"}
              MenuProps={{
                PaperProps: {
                  className: "dashboard-company-toolbar__menu",
                },
              }}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {DISCO_COMPANY_OPTIONS.map((company) => (
                <MenuItem
                  key={company.code}
                  value={company.code}
                  disabled={!isEnabledDiscoCompany(company.code)}
                >
                  {company.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            className={`dashboard-company-toolbar__show-btn${
              isShowReady
                ? " dashboard-company-toolbar__show-btn--ready"
                : " dashboard-company-toolbar__show-btn--idle"
            }`}
            onClick={onShow}
            disabled={loading || showDisabled || !selectedCompanyCode}
            startIcon={<VisibilityOutlinedIcon />}
          >
            Show
          </Button>
        </div>
      </div>
    </Box>
  );
}

DashboardCompanyToolbar.propTypes = {
  selectedCompanyCode: PropTypes.string,
  onCompanyChange: PropTypes.func.isRequired,
  onShow: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  showDisabled: PropTypes.bool,
  activeCompanyLabel: PropTypes.string,
  activeCompanyCode: PropTypes.string,
};
